var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphTypeLineGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4C59",
    d: "M22.3071724,6.27889673 C22.7054267,5.89625862 23.3384652,5.90891807 23.7211033,6.3071724 C24.0743077,6.67479179 24.0906905,7.24246388 23.7778831,7.62857803 L23.6928276,7.72110327 L15.0563084,16.01897 C14.3878686,16.6611991 13.3730152,16.7554323 12.6021486,16.2675024 L12.4606145,16.169185 L7.34999587,12.2857621 L1.6928276,17.7211033 C1.29457326,18.1037414 0.661534848,18.0910819 0.278896732,17.6928276 C-0.0743076819,17.3252082 -0.0906905022,16.7575361 0.222116853,16.371422 L0.307172404,16.2788967 L5.96434067,10.8435555 C6.63278042,10.2013264 7.64763383,10.1070933 8.41850044,10.5950231 L8.56003457,10.6933405 L13.6706532,14.5767635 L22.3071724,6.27889673 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphTypeLineGray);
export default __webpack_public_path__ + "static/media/graph_type_line_gray.f8a539b5.svg";
export { ForwardRef as ReactComponent };